<style scoped src="css/information.css"></style>
<template>
  <div class="box">
    <img class="topBg" src="~assets/spTitle.png" alt="" />
    <div class="cjjjBox" @click="showTc">
      <img class="topBg minWidth" src="~assets/cjjj.png" alt="" />
      <!-- <img class="tanchuang" v-if="showTcStatus" src="~assets/tanchuang.png" alt="" /> -->
      <div class="tanchuang"  v-if="showTcStatus">
        <div class="paddingBox">
          <div>正常：64人</div>
          <div>轻度：252人</div>
          <div>中度：48人</div>
          <div>重度：9人</div>
        </div>
      </div>
      <div class="zhezhao" @click.stop="show1216"></div>
      <img class="zhezhaoPic" v-if="show1216pic" src="~assets/1216mask1.png" alt="">
    </div>
    <div class="w14">
      <div class="relativeBox">
        <img src="~assets/cxzbT.png" alt="" class="minWidth" />
        <a @click="to('video')" class="spjs">视频介绍</a>
        <a href="https://www.itnbear.com/" class="lj">业务系统</a>
      </div>
      <div class="betweenBox">
        <div class="betweenItemBox" @click="show1216mask2">
          <img src="~assets/be1.png" alt="" />
          <div id="myChart"></div>
          <img class="mask12162" v-if="show1216mask22" src="~assets/1216mask2.png" alt="">
        </div>
        <div class="betweenItemBox"  @click="show1216mask3">
          <img src="~assets/be2.png" alt="" />
          <div id="myChart1"></div>
          <img class="mask12162" v-if="show1216mask33" src="~assets/1216mask3.png" alt="">
        </div>
      </div>
      <div class="betweenBox">
        <div class="betweenItemBox">
          <img src="~assets/be3.png" alt="" />
          <div id="myChart2"></div>
        </div>
        <div class="betweenItemBox">
          <img src="~assets/be4.png" alt="" />
          <div id="myChart3"></div>
        </div>
      </div>
      <!-- <img src="~assets/hxzb1.png" alt="" class="sp100"  style="margin: .24rem .3rem">
      <div class="ttContent">

        <div class="ttRightBox">
          <img src="~assets/ttx1.png" class="minWidth" alt="">
        </div>

        <div class="ttRightBox">
          <div v-if="ttTabStatus==0">
            <div class="hxTitle">核心指标实时数据</div>
            <div class="typeBox">
              <div class="ttType" @click="changeTtTypeStatus(index)" :class="{actived:ttTypeStatus==index}" v-for="(item,index) in ttTypeList">{{item}}</div>
            </div>
            <div class="typeContent">
              <img src="~assets/ywsj.png" class="sp50" v-if="ttTypeStatus==0" alt="">
              <img src="~assets/xlfw.png" class="sp50" v-if="ttTypeStatus==1" alt="">
              <img src="~assets/bftj.png" class="sp100" v-if="ttTypeStatus==2" alt="">
            </div>

          </div>
        </div>
      </div> -->
      <!-- <img
        src="~assets/pjtx.png"
        alt=""
        class="minWidth"
        style="margin: 0 auto"
      /> -->
    </div>
    <div class="w14">
      <img src="~assets/lczzT.png" class="minWidth" alt="" />
      <div class="gcContentBox">
        <div class="gcCTabListBox">
          <div
            class="gcCTabList"
            :class="{ active: gzStatus == index }"
            @click="changegzStatus(index)"
            v-for="(item, index) in gzTabList"
          >
            {{ item }}
          </div>
        </div>
        <div class="gcCBox">
          <img
            src="~assets/ywlc.png"
            class="minWidth"
            v-if="gzStatus == 0"
            alt=""
          />
          <img
            src="~assets/sjjc.png"
            class="minWidth"
            v-if="gzStatus == 1"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="w14">
      <img src="~assets/hxcjT.png" class="minWidth" alt="" />
      <div class="gcContentBox">
        <div class="gcCTabListBox">
          <div
            class="gcCTabList"
            :class="{ active: gcCStatus == index }"
            @click="changegcCStatus(index)"
            v-for="(item, index) in gcCTabList"
          >
            {{ item }}
          </div>
        </div>
        <div class="gcCBox">
          <img
            src="~assets/xlcp.png"
            class="minWidth"
            v-if="gcCStatus == 0"
            alt=""
          />
          <img
            src="~assets/lflk.png"
            class="minWidth"
            v-if="gcCStatus == 1"
            alt=""
          />
          <img
            src="~assets/shbf.png"
            class="minWidth"
            v-if="gcCStatus == 2"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="w14">
      <img src="~assets/sjgx.png" class="minWidth" alt="" />
      <!--      <img src="~assets/sjgxC.png" alt="">-->
    </div>

    <div class="topBox">
      <div class="ggtpBox">
        <img src="~assets/gzzb.png" class="minWidth" alt="" />
      </div>
      <div class="ggtpBox">
        <img src="~assets/gzjh.png" class="minWidth" alt="" />
      </div>
    </div>

    <div class="topBox">
      <div class="ggtpBox2">
        <!-- <div class="zcTabBox">
          <img src="~assets/line.png" alt="">
          <div class="zcTabItem active">取得成效</div>
        </div> -->
        <img src="~assets/qdcxT.png" alt="" />
        <div class="ttTabBox">
          <div
            class="ttTab"
            style=""
            @click="changeCxStatus(index)"
            :class="{ active: cxStatus == index }"
            v-for="(item, index) in cxList"
          >
            {{ item }}
          </div>
        </div>
        <div id="myChart4" v-show="false" class="auto sp90"></div>
        <!-- <div id="myChart5" v-show="cxStatus==0" class="auto sp90"></div> -->
        <img
          src="~assets/zffx.png"
          v-if="cxStatus == 1"
          alt=""
          class="auto sp90"
        />
        <img
          src="~assets/fxcd.png"
          v-if="cxStatus == 0"
          alt=""
          class="auto sp90"
        />
      </div>
      <div class="ggtpBox2">
        <div class="zcTabBox">
          <img src="~assets/line.png" alt="" />
          <div
            class="zcTabItem"
            :class="{ active: zcTabStatus == index }"
            @click="changeZcTabStatus(index)"
            v-for="(item, index) in zcList"
          >
            {{ item }}
          </div>
        </div>
        <div v-if="zcTabStatus == 0">
          <img
            src="~assets/zcCT.png"
            class="minWidth"
            alt=""
            style="margin-bottom: 0.3rem"
          />
          <img
            :src="EnvUrl + 'zcwj' + (index + 1) + '.png'"
            class="sp90"
            @click="changezcStatus(index + 1)"
            style="margin: 0 auto 0.28rem"
            alt=""
            v-for="(item, index) in 3"
          />
        </div>
        <div v-if="zcTabStatus == 1">
          <img
            src="~assets/tpqdT.png"
            class="minWidth"
            alt=""
            style="margin: 0.3rem auto"
          />
          <img
            :src="EnvUrl + 'qd0' + (index + 1) + '.png'"
            class="sp90"
            @click="changeGgtpStatus(index + 1)"
            style="margin: 0 auto 0.28rem"
            alt=""
            v-for="(item, index) in 4"
          />
        </div>
        <div v-if="zcTabStatus == 2" style="padding-top: 0.3rem">
          <img
            :src="EnvUrl + 'ddt' + index + '.png'"
            @click="changeGzdtStatus(index)"
            style="margin: 0 auto 0.24rem"
            alt=""
            v-for="(item, index) in 6"
          />
        </div>
      </div>
    </div>

    <div class="maskBox" v-if="mask" @click="closeMask()">
      <div class="mask" @click.stop>
        <div class="wm14" v-if="zcStatus > 0">
          <div class="zcTop">
            <img src="~assets/zcwj.png" alt="" />
            <div v-if="zcStatus != 0" @click.stop="changezcStatus(0)">
              返回 >
            </div>
          </div>
          <!--      <div class="zcList" v-if="zcStatus == 1">-->
          <!--        <img src="~assets/zcd1.png" alt="">-->
          <!--      </div>-->
          <div class="zcList" v-if="zcStatus == 1">
            <img :src="EnvUrl + 'zcd2.png'" alt="" class="zcImg minWidth" />
          </div>
          <div class="zcList" v-if="zcStatus == 2">
            <img :src="EnvUrl + 'zcd3.png'" alt="" class="zcImg minWidth" />
          </div>
          <div class="zcList" v-if="zcStatus == 3">
            <img :src="EnvUrl + 'zcd4.png'" alt="" class="zcImg minWidth" />
          </div>
        </div>

        <div class="wm14" v-if="ggtpStatus > 0">
          <div class="zcTop">
            <img src="~assets/ggtpT.png" alt="" />
            <div @click="changeGgtpStatus(0)">返回 ></div>
          </div>
          <div class="zcList" v-if="ggtpStatus >= 0">
            <img
              :src="EnvUrl + 'qdx0' + ggtpStatus + '.png'"
              class="minWidth"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <!--    工作动态-->
    <div class="wm14" v-if="gzdtStatus >= 0">
      <div class="zcTop">
        <img src="~assets/gzdtT.png" alt="" />
        <div v-if="gzdtStatus >= 0" @click="changeGzdtStatus(-1)">返回 ></div>
      </div>
      <div class="zcList" v-if="gzdtStatus >= 0">
        <img :src="EnvUrl + 'dtx' + gzdtStatus + '.png'" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";
import noMoreData from "components/no-more-data";
import newsTopBox from "components/newsTopBox";
import topbar from "components/topbar";
import moment from "moment/moment";
import footerBox from "components/footer";
import { Swiper, Slide } from "vue-swiper-component";
import wx from "weixin-js-sdk";
import echarts from "echarts";
let components = {
  noMoreData,
  topbar,
  Swiper,
  Slide,
  footerBox,
  newsTopBox,
};
export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      show1216pic:false,
      showTcStatus:false,
      show1216mask22:false,
      show1216mask33:false,
      workUserCount: "",
      allUserCount: "",
      workUserList: "",
      zcList: ["政策体系", "改革突破清单"],
      zcTabStatus: 0,
      cxList: ["矫正对象危险程度", "矫正对象再犯风险"],
      cxStatus: 0,
      list: [
        {
          title: "天台司法行政数字化改革工作方案",
          time: "2021年05月17日",
        },
        {
          title: "台司（2021）27号台州市司法局数字化改革工作方案",
          time: "2021年05月07日",
        },
        {
          title: "(20210420)6月更新 天台县司法局社区矫正数字改革信息速递",
          time: "2021年04月20日",
        },
        {
          title: "(20201209)关于成立天台县社区矫正委员会的通知",
          time: "2020年12月09日",
        },
        {
          title: "关于建立市社区矫正委员会的通知",
          time: "2020年11月16日",
        },
      ],
      id: 0,
      arr: [],
      val: [],
      type: [
        {
          name: "全部",
          id: 0,
        },
        {
          name: "重度",
          id: 1,
        },
        {
          name: "中度",
          id: 2,
        },
        {
          name: "轻度",
          id: 3,
        },
        {
          name: "无症状",
          id: 4,
        },
      ],
      tabList: ["首页", "指标体系", "政策体系", "评价体系"],
      tabStatus: 0,
      ttTabList: ["社区矫正对象基本情况", "核心指标实时数据"],
      ttTabStatus: 0,
      ttTypeList: ["业务数据图", "心理服务统计图", "帮扶统计图"],
      ttTypeStatus: 0,
      gzTabList: ["业务流程", "数据集成"],
      gzStatus: 0,
      gcCTabList: ["心理服务", "联防联控", "社会e帮扶"],
      gcCStatus: 0,
      zcStatus: 0,
      gzdtStatus: -1,
      ggtpStatus: 0,
      mask: false,
      flag: true,
    };
  },
  components: components,
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
    show1216mask2(){
      this.show1216mask22=!this.show1216mask22
    },
    show1216mask3(){
      this.show1216mask33=!this.show1216mask33
    },
    show1216(){
      this.show1216pic=!this.show1216pic
    },
    showTc(){
      this.showTcStatus=!this.showTcStatus
    },
    changeZcTabStatus(i) {
      this.zcTabStatus = i;
    },
    changeCxStatus(i) {
      console.log(i);
      this.cxStatus = i;
    },
    closeMask() {
      this.mask = false;
      this.ggtpStatus = 0;
      this.zcStatus = 0;
    },
    changeGgtpStatus(i) {
      if (i == 0) {
        this.flag = true;
        this.mask = false;
      } else {
        this.flag = false;
        this.mask = true;
      }
      this.ggtpStatus = i;
    },
    changeStatus(i) {
      this.tabStatus = i;
    },
    changeTtTabStatus(i) {
      this.ttTabStatus = i;
    },
    changeTtTypeStatus(i) {
      this.ttTypeStatus = i;
    },
    changegzStatus(i) {
      this.gzStatus = i;
    },
    changegcCStatus(i) {
      this.gcCStatus = i;
    },
    changezcStatus(i) {
      if (i > 0) {
        this.flag = false;
        this.mask = true;
      } else {
        this.flag = true;
        this.mask = false;
      }
      this.zcStatus = i;
    },
    changeGzdtStatus(i) {
      if (i == -1) {
        this.flag = true;
      } else {
        this.flag = false;
      }
      this.gzdtStatus = i;
    },
    change(i) {
      this.val = [];
      this.id = i;
      if (i == 2) {
        this.workUserList.forEach((v) => {
          this.val.push(v.twoCount);
        });
      } else if (i == 3) {
        this.workUserList.forEach((v) => {
          this.val.push(v.oneCount);
        });
      } else if (i == 4) {
        this.workUserList.forEach((v) => {
          this.val.push(v.zeroCount);
        });
      } else if (i == 1) {
        this.workUserList.forEach((v) => {
          this.val.push(v.threeCount);
        });
      } else {
        this.workUserList.forEach((v) => {
          this.val.push(v.zeroCount + v.oneCount + v.twoCount + v.threeCount);
        });
      }
      this.aa();
    },
    toDetail(i) {
      this.$router.push(`/informationWord?index=${i + 1}`);
    },
    async setEcharts() {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById("myChart2"));
      var myChart2 = echarts.init(document.getElementById("myChart3"));
      var myChart6 = echarts.init(document.getElementById("myChart"));
      var myChart7 = echarts.init(document.getElementById("myChart1"));
      var myChart4 = echarts.init(document.getElementById("myChart4"));

      // 指定图表的配置项和数据
      var option = {
        // title: {
        //     text: `出生地总人数(个)：${this.birthPlaceOne + this.birthPlaceZero}`,
        //     // subtext: '300',
        //     left: 20,
        //     top:20
        // },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: 20,
          bottom: 20,
          data: ["家庭经济较好", "家庭经济一般", "家庭经济困难"],
        },
        color: ["#69ADF2", "#FCB63D", "#FF662A"],
        series: [
          {
            name: "家庭经济情况",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["60%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 12, name: "家庭经济较好" },
              { value: 331, name: "家庭经济一般" },
              { value: 31, name: "家庭经济困难" },
            ],
          },
        ],
      };
      var option2 = {
        // title: {
        //     text: `是否独生子女（个）：${this.onlyChildZero + this.onlyChildOne}`,
        //     // subtext: '300',
        //     left: 20,
        //     top:20
        // },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: 20,
          bottom: 20,
          data: [
            "线上心理咨询",
            "一般心理问题疏导",
            "线上心理内容学习",
            "线上心理矫正",
            "线下科普讲座",
            "线下咨询",
            "危机干预",
            "线下专家会诊",
          ],
        },
        color: [
          "#69ADF2",
          "#FF7461",
          "#9584FF",
          "#38D7C4",
          "#FAB24B",
          "#EC3B5D",
          "#8FEC92",
          "#FF662A",
        ],
        series: [
          {
            name: "是否独生子女",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["60%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 260, name: "线上心理咨询" },
              { value: 256, name: "一般心理问题疏导" },
              { value: 8972, name: "线上心理内容学习" },
              { value: 560, name: "线上心理矫正" },
              { value: 78, name: "线下科普讲座" },
              { value: 112, name: "线下咨询" },
              { value: 3, name: "危机干预" },
              { value: 3, name: "线下专家会诊" },
            ],
          },
        ],
      };
      var option6 = {
        // title: {
        //     text: '压力程度统计（个）',
        //     // subtext: '300',
        //     left: 20,
        //     top:20
        // },
        // legend: {
        //     data: ['非常满意', '比较满意', '一般', '不太满意', '非常不满意', '无所谓']
        // },
        tooltip: {
          // trigger: 'axis',
          // axisPointer: {            // 坐标轴指示器，坐标轴触发有效
          //     type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
          // }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: ["正常", "轻度", "中度", "重度"],
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            minInterval: 1,
          },
        ],
        series: [
          {
            name: "测评人数",
            type: "bar",
            barWidth: "30%",
            data: [64, 252, 48, 9],
            //配置样式
            itemStyle: {
              //通常情况下：
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: "#79C7F3",
                barBorderRadius: [30, 30, 0, 0],
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#9C9C9C",
                    fontSize: 14,
                  },
                },
              },
              //鼠标悬停时：
              // emphasis: {
              //     shadowBlur: 10,
              //     shadowOffsetX: 0,
              //     shadowColor: 'rgba(0, 0, 0, 0.5)'
              // }
            },
          },
        ],
      };
      var option7 = {
        // title: {
        //     text: '咨询处理结果统计（个）',
        //     // subtext: '300',
        //     left: 20,
        //     top:20
        // },
        tooltip: {
          // trigger: 'item',
          // formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: ["满意", "一般", "不满意"],
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            minInterval: 1,
          },
        ],
        series: [
          {
            name: "满意程度",
            type: "bar",
            barWidth: "30%",
            data: [262, 112, 0],
            //配置样式
            itemStyle: {
              //通常情况下：
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: "#79C7F3",
                barBorderRadius: [30, 30, 0, 0],
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#9C9C9C",
                    fontSize: 14,
                  },
                },
              },
              //鼠标悬停时：
              // emphasis: {
              //     shadowBlur: 10,
              //     shadowOffsetX: 0,
              //     shadowColor: 'rgba(0, 0, 0, 0.5)'
              // }
            },
          },
        ],
      };
      var option4 = {
        xAxis: {
          type: "category",
          data: [
            "202101",
            "202102",
            "202103",
            "202104",
            "202105",
            "202106",
            "202107",
            "202108",
          ],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [3, 8, 7, 5, 6, 5, 4, 2],
            type: "line",
            smooth: true,
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      myChart2.setOption(option2);
      myChart6.setOption(option6);
      myChart7.setOption(option7);
      myChart4.setOption(option4);
    },
    aa() {
      let that = this;
      let myChart1 = echarts.init(document.getElementById("myChart1"));
      myChart1.setOption({
        tooltip: {
          // trigger: 'axis',
          // axisPointer: {            // 坐标轴指示器，坐标轴触发有效
          //     type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
          // }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: that.arr,
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            minInterval: 1,
          },
        ],
        series: [
          {
            name: "总人数",
            type: "bar",
            barWidth: "30%",
            data: that.val,
            //配置样式
            itemStyle: {
              //通常情况下：
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#67D5FD",
                  },
                  {
                    offset: 1,
                    color: "#58A0FF",
                  },
                ]),
                barBorderRadius: [30, 30, 0, 0],
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#9C9C9C",
                    fontSize: 14,
                  },
                },
              },
              //鼠标悬停时：
              // emphasis: {
              //     shadowBlur: 10,
              //     shadowOffsetX: 0,
              //     shadowColor: 'rgba(0, 0, 0, 0.5)'
              // }
            },
          },
        ],
      });
    },
    to(n) {
      this.$router.push(`/${n}`)
    },
    clickMe(n) {
      if (n) {
        location.href = n;
      }
    },
    async getScaleBannerList() {
      let data = await getSources(
        "/bear-scale/api/micro/getMicroBannerList.json",
        {}
      );
      if (data.status === 0) {
        this.microBannerList = data.microBannerList;
      } else {
        alert(data.msg);
      }
    },
    changeBespeakAbled(n) {
      this.bespeakAbled = n;
      this.pageIndex = 1;
      this.doctorList = [];
      this.getDoctorList();
    },
    async getScaleData() {
      let obj = {};
      obj.type = 3;
      let data = await getSources(
        "/bear-scale/api/scaleData/getScaleData.json",
        obj
      );
      if (data.status === 0) {
        this.workUserCount =
          data.workUserList[0].zeroCount +
          data.workUserList[0].oneCount +
          data.workUserList[0].twoCount +
          data.workUserList[0].threeCount;
        this.allUserCount = data.workUserList[0].userCount;
        this.drawLine();
      } else {
        alert(data.msg);
      }
    },
    async getScaleData2() {
      let obj = {};
      obj.type = 2;
      let data = await getSources(
        "/bear-scale/api/scaleData/getScaleData.json",
        obj
      );
      if (data.status === 0) {
        this.workUserList = data.workUserList;
        this.workUserList.forEach((v) => {
          this.arr.push(v.shortName);
          this.val.push(v.zeroCount + v.oneCount + v.twoCount + v.threeCount);
        });
        this.aa();
      } else {
        alert(data.msg);
      }
    },
    handleScroll() {
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let bottomOfWindow =
        document.documentElement.offsetHeight -
          scrolltop -
          window.innerHeight <=
        200;
      if (bottomOfWindow && this.isLoading == false) {
        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
          this.noMoreData = true;
        } else {
          this.isLoading = true;
          this.pageIndex = this.pageIndex + 1;
          this.getDoctorList();
        }
      }
    },
    toNone() {
      const isZzd =
        JSON.stringify(navigator.userAgent).indexOf("TaurusApp") > -1;
      if (!isZzd) {
        location.href =
          "https://dgov-integrate.jinhua.gov.cn:5443/szjh-gov-pc/#/404";
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    localStorage.setItem("sp", true);
    document.title =
      "天台县社区矫正“一体式”心理矫治系统（阳光治矫）/杭州帅熊网络科技有限公司";
    // this.drawLine()
    this.toNone();
    this.setEcharts();
    // this.getScaleData()
    // this.getScaleData2()
  },
};
</script>



// WEBPACK FOOTER //
// src/components/information.vue?5fecbb28